export const POSITIVE_CONCLUSION = "POSITIVE_CONCLUSION";
export const NEGATIVE_CONCLUSION = "NEGATIVE_CONCLUSION";

export const FINDING_CARD_TYPE = "finding_subject_dnd";
export const SCANNING_SUBJECT_CARD_TYPE = "question_card_dnd";
